import { useState, useEffect } from "react";
import SummaryApi from "../common";

const ProductCategory1 = () => {
    const [categories, setCategories] = useState([]);

    useEffect(() => {
        const fetchCategories = async () => {
            try {
                console.log("Fetching categories...");
                const response = await fetch(SummaryApi.getCategories.url, {
                    method: SummaryApi.getCategories.method,
                    credentials: "include",
                    headers: {
                        "Content-Type": "application/json",
                    },
                });
                const data = await response.json();
                console.log("Fetched categories:", data); // Debugging log

                if (data.success) {
                    setCategories(data.categories);
                } else {
                    console.warn("API response does not indicate success:", data);
                }
            } catch (error) {
                console.error("Error fetching categories:", error);
            }
        };

        fetchCategories();
    }, []);

    return categories;
};

export default ProductCategory1;
